<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>
            {{ 'project.modal.title.' + modalTitle | translate }}
        </h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="modal-body">
        <h6>Locations</h6>
        <ul class="list-unstyled">
            <li *ngFor="let node of historyService.autoConfigRingsErrorNodes">
                <winde-node-pointer [listData]="{ nodeNames: node.nodeid, placement: 'top', cropName: 25 }"></winde-node-pointer>
            </li>
        </ul>
    </div>
</div>
